import { ScenarioStatusBase } from './base/scenario-status-base';

export class ScenarioStatus extends ScenarioStatusBase { }